export default "__VITE_ASSET__Cv0VFhLQ__"